export default __webpack_public_path__ + "static/media/gallery_02.5f4a4b74.jpg";